export const isLojaBelaHome = localStorage.idconta === '111111111'
